
import domain1Logo from '../assets/images/logo.png';
// import domain2Logo from '../assets/logos/domain2-logo.png';

const BRANDING_CONFIG = {
    'app.onlinemasterscolleges.com': {
        name: 'Brand One',
        logo: domain1Logo,
        portalID: 1,
        colors: {
            primaryColor: "#00ba16",
            background: "#ebf2fc",
            headerBg: '#ffffff',
            textBlack: "#000000",
            textWhite: "#ffffff",
            buttonBg: '#00ba16',
            secondaryButtonBg: '#D51B32',
            buttonText: '#ffffff',
            popupBg: "#FFF2DA"
        },
    },
    'domain2.com': {
        name: 'Brand Two',
        logo: '/assets/domain2-logo.png',
        portalID: 2,
        colors: {
            background: "ebf2fc",
            headerBg: '#ffffff',
            buttonBg: '#00ba16',
            buttonText: '#ffffff',
        },
    },
};

export default BRANDING_CONFIG;
